export enum UIRefreshCategoryEnum {
    Trending = 1,
    SummaryListing,
    Details,
    WellReview
}
